import { PrimaryFullScreenSpinner, TabLink, TabLinkContainer } from "@repo/ui";
import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/ledger/accounts_/$accountId")({
  head: () => opsHead("Ledger Account"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  const params = useParams({ strict: false });

  return (
    <AdminPageContainer>
      <AdminPageHeader title="Account" subtitle={params.accountId} />
      <TabLinkContainer className="mb-10" size="sm">
        <TabLink
          to={`/ledger/accounts/${params.accountId}`}
          title="Overview"
          end
        />
        <TabLink
          to={`/ledger/accounts/${params.accountId}/balances`}
          title="Balances"
        />
        <TabLink
          to={`/ledger/accounts/${params.accountId}/entries`}
          title="Entries"
        />
      </TabLinkContainer>
      <div className="mt-4">
        <Outlet />
      </div>
    </AdminPageContainer>
  );
}
